import { ILayer } from './LayersState';
import { ILiveSheetState } from './ILiveSheetState';

/**
 * Tries to find a layer by id. May return null.
 */
export function lookupLayerByIdReducer(state: ILiveSheetState, id: string): ILayer | null {
  return state.layers.find(($) => $.id === id) || null;
}
